import { usePintoEbookCollectionsQuery } from '../core/graphql/operation-hooks';
import { PintoEbookCollectionsFilter } from '../core/graphql/types';

export type IPropsUseQueryPintoEbookCollections = PintoEbookCollectionsFilter;

const useQueryPintoEbookCollections = (props?: IPropsUseQueryPintoEbookCollections) => {
  const { data, loading } = usePintoEbookCollectionsQuery({ variables: { filter: props } });

  return {
    pintoEbookCollections: data?.pintoEbookCollections,
    isLoadingPintoEbookCollections: loading,
  };
};

export default useQueryPintoEbookCollections;
